import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classes from "./Submit.module.scss";
import cl from "classnames";
import LoadablePrimaryButton from "venuescanner-js/react/components/Buttons/PrimaryButton";
const Submit = ({ visible = true, children }) => (
  <LoadablePrimaryButton
    type="submit"
    className={cl([classes.submit, { [classes["submit-visible"]]: visible }])}
  >
    {children}
  </LoadablePrimaryButton>
);

export default Submit;
